import React from "react";

import "./ExpandIcon.css";

const ExpandIcon = () => {
  return (
    <div className="delicious100-interactive__inverted-triangle">
      <div className=""></div>
    </div>
  );
};

export default ExpandIcon;
